export default __webpack_public_path__ + "static/media/Malabar-Diocese.735d4e60.png";